import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { IconButton, Grid } from '@mui/material';
import { useState } from 'react';

const ExpandableContainer = ({ header, body, defaultOpen = false }) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    const toggleOpen = () => {
        setIsOpen(prev => !prev);
    };

    return (
        <div style={{ 
            marginBottom: '1rem', 
            width: '100%', 
            border: '1px solid #D3D3D3',
            borderRadius: '8px',
            padding: '0.5rem'
        }}>
            <Grid container spacing={1} alignItems="center" style={{ width: '100%' }}>
                <Grid item>
                    <DragIndicatorIcon />
                </Grid>
                <Grid item>
                    <IconButton color="primary" onClick={toggleOpen}>
                        {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </IconButton>
                </Grid>
                <Grid item xs>
                    {header}
                </Grid>
            </Grid>
            {isOpen && (
                <Grid item xs={12} style={{ marginTop: '1rem', paddingLeft: '13px' }}>
                    {body}
                </Grid>
            )}
        </div>
    );
};

export default ExpandableContainer;
